<p class="attrib_settings_container">
  <span class="attrib_setting_name">{{ displayName }}</span>
  <button mat-button class="attrib_clear_button" type="button" (click)="clearAttrib()">
    <mat-icon class="attrib_setting_clear_icon">close</mat-icon>
  </button>
</p>
<glxy-form-field>
  <mat-select [formControl]="control" class="attrib_enum_input" placeholder="{{ displayName }}">
    <mat-option *ngFor="let option of selectOptions" [value]="option">{{ option }}</mat-option>
  </mat-select>
</glxy-form-field>
